// useStats.ts
import { useState, useMemo } from 'react'
import { format, parse } from 'date-fns'
import { ru } from 'date-fns/locale'
import { MetricsDetailed } from '../../../../../common/types/interfaces'

const formatDate = (date: string, granularity: 'day' | 'week' | 'month'): string => {
  if (granularity === 'day') {
    return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd.MM', { locale: ru })
  }
  if (granularity === 'week') {
    return date.split('-W')[1] + ' нед.'
  }
  return format(parse(date, 'yyyy-MM', new Date()), 'LLLL', { locale: ru })
}

export const useStats = (metrics: MetricsDetailed | null) => {
  const [granularity, setGranularity] = useState<'day' | 'week' | 'month'>('day')

  const chartData = useMemo(() => {
    if (!metrics?.data) return []
    return metrics.data
      .filter((p) => {
        if (granularity === 'day') return p.date.length === 10
        if (granularity === 'week') return p.date.startsWith('20') && p.date.includes('-W')
        return p.date.length === 7
      })
      .map((p) => ({
        date: formatDate(p.date, granularity),
        Визиты: Number(p.visits) || 0,
        Лиды: Number(p.goals.call_request || 0),
        Звонки: Number(p.goals.call_click || 0),
        Заказы: Number((p.goals.order_complete || 0) + (p.goals.project_order || 0)),
      }))
  }, [metrics, granularity])

  const hasData = chartData.some(
    (d) => d.Визиты > 0 || d.Лиды > 0 || d.Звонки > 0 || d.Заказы > 0,
  )

  return { granularity, setGranularity, chartData, hasData }
}